module.exports = "<div ba-panel ba-panel-title=\"{{'Form data for' | translate }} <strong>{{$ctrl.page.title}}</strong>\" ba-panel-class=\"\">\n    <div ng-if=\"$ctrl.columns\">\n        <page-form-data-grid initial-params=\"$ctrl.initialParams\" on-params-change=\"$ctrl.onParamsChange(params)\" on-page-change=\"$ctrl.onPageChange($page)\" columns=\"$ctrl.columns\" total-count=\"$ctrl.total_count\"></page-form-data-grid>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsPages/Pages/templates/pageFormDataList.html
// module id = 1017
// module chunks = 0